require('./protectionSetPicker.style.scss');
const { permissions } = require('../../../../constants/permissions');
const Subscription = require('../../../../model/Subscription');


const HELP_MAIN = 'protection-sets',
    HELP_MAIN_MANAGE = 'protection-sets-manage',
    HELP_CREATE = 'protection-set-create',
    HELP_EDIT = 'protection-set-edit';

class ProtectionSetPickerController {
    constructor($element, $scope, $rootScope, $filter, $timeout, $document, $compile, storageService, contentSwitcherService, validationsService, dialogService, persistence, notificationService, sharedPersistenceService, sseService, loginService, principalService, iamPersistenceService) {
        this.$element = $element;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.$document = $document;
        this.$compile = $compile;
        this.storageService = storageService;
        this.animateSwitcher = typeof this.$element[0].getBoundingClientRect === 'function';
        this.contentSwitcherService = contentSwitcherService;
        this.validationsService = validationsService;
        this.iamPersistenceService = iamPersistenceService;
        this.dialogService = dialogService;
        this.persistence = persistence;
        this.notificationService = notificationService;
        this.sharedPersistenceService = sharedPersistenceService;
        this.sseService = sseService;
        this.loginService = loginService;
        this.principalService = principalService;

        this.vmNamePattern = this.validationsService.getNewvmNamePattern();

        this.mainTitle = (this.$filter('translate')('picker.dialog.title'));
        this.modalTitle = this.mainTitle;
        this.modalSubTitle = null;
        this.pickerTableArray = [];
        this.expandedItems = [];
        this.selectedResourceGroups = [];

        this.CREATE_STATE = 'create';
        this.EDIT_STATE = 'edit';
        this.MAIN_STATE = 'main';
        this.searchTree = '';
        this.searchRg = '';

        this.isEdit = true;

        this.configResourceGroupsTable();
    }



    $onInit() {
        this.actionButtons = [
            {
                title: this.$filter('translate')('toolbar.default.back.label'),
                action: () => { this.onBackAction(); },
                isVisible: () => this.state !== this.MAIN_STATE,
                // btnClass: 'ctx-btn-secondary',
                id: 'notification-back'
            },
            {
                title: this.$filter('translate')('common.form.default.btn.select.label'),
                type: 'submit',
                action: this.saveProtectionSetSelection.bind(this),
                isVisible: () => this.state === this.MAIN_STATE,
                isDisabled: () => !this.selectedProtectionSet || this.selectedProtectionSet.isActive,
                id: 'protection-set-select'
            }
            ,
            {
                title: this.$filter('translate')('common.form.default.btn.save.label'),
                type: 'submit',
                action: () => this.saveProtectionSet(),
                isVisible: () => this.state !== this.MAIN_STATE,
                isDisabled: () => (this.dialogForm && !this.dialogForm.$valid) || this.busy,
                id: 'protection-set-save'
            }
        ];

        this.$scope.$watch(() => this.subscription, subscription => {
            if (this.allSubscriptions) {
                this.selectedProtectionSet = null;
                this.selectedSubscription = this.allSubscriptions.filter(pr => pr.uuid === this.subscription.value)[0];
                this.iamPersistenceService.getPermissions(this.selectedSubscription.managerEndpointUrl, this.selectedSubscription.uuid).then((res) => {
                    this.storageService.setTempPermissions(res);
                    this.setProtectionSetsTable();
                });
            }
        });

    }

    configResourceGroupsTable() {
        this.groupsTableColumnNames = [
            this.$filter('translate')('picker.resourceGroups.table.header.name'),
            this.$filter('translate')('picker.resourceGroups.table.header.protectionSetName')
        ];
    }

    setGrid(grid) {
        this.grid = grid;
        this.ctxGridStyleConfig = {
            multiselect: true,
            columnsWidthMapInPct: []
        };
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('6%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('50%');
        this.ctxGridStyleConfig.columnsWidthMapInPct.push('44%');

        this.$timeout(() => {
            this.grid.tableName = this.grid.tableName + '-' + this.storageService.getUsername();
            if (angular.isDefined(this.storageService.getGridWolumnsWidthMapInPct(this.grid.tableName))) {
                this.ctxGridStyleConfig.columnsWidthMapInPct = this.storageService.getGridWolumnsWidthMapInPct(this.grid.tableName);
            }
            this.gridColumnsStyleConfig = this.ctxGridStyleConfig;
            this.gridFlag = true;
        }, 0);
    }

    toggleChildren(data) {
        data.childrenVisible = !data.childrenVisible;
    };

    onOpen() {
        this.helpId = this.isEdit ? HELP_MAIN_MANAGE : HELP_MAIN;
        this.state = this.MAIN_STATE;
        this.selectedProtectionSet = null;
        this.load();

        this.closeId = { close: 'nutanix-cluster-close', closeIcon: 'nutanix-cluster-close-icon' };
        this.configPickerTable();
        this.idx = 0;

        this.bindOnClickFunction();
    }

    load() {
        this.pickerTableArray = [];
        this.isFirstLoad = true;
        this.busyFull = true;
        this.persistence.getScopeSubscriptions().then((subs) => {
            this.allSubscriptions = subs;
            this.availableSubscriptions = subs.map((elem, i) => {
                return {
                    id: i,
                    label: elem.name,
                    value: elem.uuid,
                    managerEndpointUrl: elem.managerEndpointUrl
                };
            });
            this.subscription = this.availableSubscriptions.filter(pr => pr.value === this.storageService.getSubscription().uuid)[0];
            this.selectedSubscription = this.allSubscriptions.filter(pr => pr.uuid === this.subscription.value)[0];
        });
    }

    setProtectionSetsTable() {
        this.pickerTableArray = [];
        this.isFirstLoad ? this.busy = false : this.busy = true;
        this.isFirstLoad = false;
        this.$timeout(() => {
            this.persistence.getProtectionSetsBySub(this.selectedSubscription, this.searchTree).then(
                (protectionSets) => {
                    const currentProtectionSet = this.storageService.getProtectionSet();
                    this.isFirstProtectionSetLoad = true;
                    this.obj = protectionSets;
                    this.obj.forEach((protectionSet) => {
                        protectionSet.isActive = currentProtectionSet.uuid === protectionSet.uuid ? true : false;
                    });
                    this.expandedItems = [];
                    this.buildPickerTree(this.obj);
                    this.setProtectionSetExpansion();
                    this.isFirstProtectionSetLoad = false;
                    if (this.protectionSet) {
                        this.selectedProtectionSet = this.obj.filter(protectionSet => protectionSet.name === this.protectionSet.name)[0];
                    }
                }, err => {
                    this.busy = false;
                    this.notificationService.pop({
                        type: "ERROR",
                        title: this.$filter('translate')('picker.dialog.manager.error.title', { name: this.selectedSubscription.name }),
                        details: this.$filter('translate')('picker.dialog.manager.error.detail')
                    });
                }
            );
        }, 500
        );
    }

    setProtectionSetExpansion() {
        this.$timeout(() => {
            $('.protection-set').each(function () {
                var findChildren = function (tr) {
                    var depth = tr.data('depth');
                    return tr.nextUntil($('tr').filter(function () {
                        return $(this).data('depth') <= depth;
                    }));
                };

                var el = $(this);
                var tr = el.closest('tr'); //Get <tr> parent of toggle button
                var children = findChildren(tr);

                //Remove already collapsed nodes from children so that we don't
                //make them visible. 
                //(Confused? Remove this code and close Item 2, close Item 1 
                //then open Item 1 again, then you will understand)
                var subnodes = children.filter('.expand');
                subnodes.each(function () {
                    var subnode = $(this);
                    var subnodeChildren = findChildren(subnode);
                    children = children.not(subnodeChildren);
                });
                //Change icon and hide/show children
                if (tr.hasClass('collapsed')) {
                    tr.removeClass('collapsed').addClass('expand');
                    children.hide();
                } else {
                    tr.removeClass('expand').addClass('collapsed');
                    children.show();
                }
                return children;
            });
        }, 0);

        this.$timeout(() => {
            this.busy = false;
            this.busyFull = false;
        }, 500);
    }

    loadRGroups() {
        this.resourceGroups = [];
        this.busy = true;
        return this.persistence.getResourceGroups(this.selectedSubscription, this.searchRg).then(
            resourceGroups => {
                this.resourceGroups = resourceGroups;
                this.busy = false;
            }
        );
    }

    bindOnClickFunction() {
        this.$timeout(() => {
            $(function () {
                $('#protection-set-tree-table').on('click', '.toggle', function () {
                    //Gets all <tr>'s  of greater depth
                    //below element in the table
                    var findChildren = function (tr) {
                        var depth = tr.data('depth');
                        return tr.nextUntil($('tr').filter(function () {
                            return $(this).data('depth') <= depth;
                        }));
                    };

                    var el = $(this);
                    var tr = el.closest('tr'); //Get <tr> parent of toggle button
                    var children = findChildren(tr);

                    //Remove already collapsed nodes from children so that we don't
                    //make them visible. 
                    //(Confused? Remove this code and close Item 2, close Item 1 
                    //then open Item 1 again, then you will understand)
                    var subnodes = children.filter('.expand');
                    subnodes.each(function () {
                        var subnode = $(this);
                        var subnodeChildren = findChildren(subnode);
                        children = children.not(subnodeChildren);
                    });

                    //Change icon and hide/show children
                    if (tr.hasClass('collapsed')) {
                        tr.removeClass('collapsed').addClass('expand');
                        children.hide();
                    } else {
                        tr.removeClass('expand').addClass('collapsed');
                        children.show();
                    }
                    return children;
                });
            });
        }, 0);
    }

    buildPickerTree(protectionSets) {
        var k;
        if (protectionSets instanceof Object) {
            for (k in protectionSets) {
                if (protectionSets.hasOwnProperty(k)) {
                    if (k === 'name') {
                        this.idx++;
                        protectionSets.depth = this.idx;
                        this.pickerTableArray.push(protectionSets);
                        ((protectionSets.type === 'protectionSet' && this.isFirstLoad)) ? this.expandedItems.push(true) : this.expandedItems.push(false);
                    }
                    this.buildPickerTree(protectionSets[k]);
                }
            }
            if (!Array.isArray(protectionSets)) {
                this.idx--;
            }
        }
    }

    configPickerTable() {
        this.columnNames = [
            this.$filter('translate')('vm.table.header.name'),
        ];

        this.tblBody = this.$document[0].getElementById('tbl-content');
    }

    isDefaultResourceGroup() {
        if (this.selectedResourceGroup) {
            const resourceGroup = this.pickerTableArray.filter(item => item.uuid === this.selectedResourceGroup.parent);
            return resourceGroup[0].default;
        }
    }

    selectProtectionSet(item) {
        if (item.type === "resourceGroup") {
            this.selectedResourceGroup = item;
            this.selectedProtectionSet = null;
        }
        if (item.type === 'protectionSet') {
            this.selectedProtectionSet = item;
            this.selectedResourceGroup = null;
        }
    }

    toggle(index) {
        if (this.expandedItems[index] === true) {
            this.expandedItems[index] = false;
        } else {
            if (this.pickerTableArray[index].type === 'subscription') {
                this.addProtectionSetsToSub(this.pickerTableArray[index].uuid);
            }
            this.expandedItems[index] = true;
        }
    }

    onBackAction() {
        this.searchTree = "";
        this.selectedResourceGroups = [];
        if (this.animateSwitcher) {
            this.contentSwitcherService.removeAutoHeight(this.$element.find('.ctx-content-switcher')).then(() => {
                this.onModalBack();
                this.setProtectionSetsTable();
            });
        } else {
            this.onModalBack();
            this.setProtectionSetsTable();
        }
    }

    changeState(state) {
        if (this.animateSwitcher) {
            this.contentSwitcherService.removeAutoHeight(this.$element.find('.ctx-content-switcher')).then(() => {
                this.changeStateAction(state);
            });
        } else {
            this.changeStateAction(state);
        }
    }

    changeStateAction(state) {
        if (state === this.MAIN_STATE) {
            this.helpId = this.isEdit ? HELP_MAIN_MANAGE : HELP_MAIN;
            this.modalTitle = this.mainTitle;
            this.modalSubTitle = null;
            // this.busy = false;
        }
        else {
            this.modalTitle = this.mainTitle;
            this.modalSubTitle = (' » ') + (state === this.CREATE_STATE ? this.$filter('translate')('vm.credentials.new.title') : this.$filter('translate')('vm.credentials.edit.title') + ' ' + this.protectionSet.name);
            this.helpId = state === this.CREATE_STATE ? HELP_CREATE : HELP_EDIT;

        }
        this.state = state;
    }

    newProtectionSet() {
        this.searchRg = "";
        this.protectionSet = this.persistence.newProtectionSet();
        this.changeState(this.CREATE_STATE);
        this.busy = true;
        this.persistence.getResourceGroups(this.selectedSubscription).then(
            resourceGroups => {
                this.resourceGroups = resourceGroups;
                this.busy = false;
            }
        );
    }

    saveProtectionSet() {
        this.protectionSet.resourceGroups = this.selectedResourceGroups.map(item => item.uuid);
        this.busy = true;
        this.persistence[this.state === this.CREATE_STATE ? 'createProtectionSet' : 'updateProtectionSet'](this.selectedSubscription, this.protectionSet).then(res => {
            if (this.state === 'edit' && (this.selectedProtectionSet.uuid === this.storageService.getProtectionSet().uuid)) {
                this.storageService.setProtectionSet({
                    uuid: this.selectedProtectionSet.uuid,
                    name: this.protectionSet.name
                });
                this.$rootScope.$emit("protection-set-edit");
            }
            this.notificationService.pop(res.data.message);
        }, err => {
        }).finally(() => {
            this.setProtectionSetsTable();
            this.selectedResourceGroups = [];
            this.searchTree = '';
            this.onModalBack();
            this.changeState(this.MAIN_STATE);
        });
    }

    deleteAction() {
        if (this.selectedResourceGroup) {
            this.removeResourceGroupAction();
        }
        if (this.selectedProtectionSet) {
            this.deleteProtectionSet();
        }
    }

    removeResourceGroupAction() {
        const protectionSetObj = this.pickerTableArray.find(pSet => pSet.uuid === this.selectedResourceGroup.parent);
        this.dialogService.showYesNo(this.$filter('translate')("vm.vmResourceGroups.deleteDialog.text", { name: this.selectedResourceGroup.name, protectionName: protectionSetObj.name }), this.$filter('translate')('vm.vmResourceGroups.deleteDialog.title'), null, 'delete-cg')
            .then(result => {
                if (result) {
                    this.removeResourceGroup();
                }
            }).then(() => {
            }, err => this.err = err);
    }

    removeResourceGroup() {
        const protectionSetToUpdate = this.persistence.newProtectionSet();
        const protectionSetObj = this.pickerTableArray.find(pSet => pSet.uuid === this.selectedResourceGroup.parent);
        const resourceGroups = protectionSetObj.items.filter(resGroup => resGroup.uuid !== this.selectedResourceGroup.uuid).map(resGroup => resGroup.uuid);
        protectionSetToUpdate.name = protectionSetObj.name;
        protectionSetToUpdate.uuid = protectionSetObj.uuid;
        protectionSetToUpdate.resourceGroups = resourceGroups;
        this.persistence.updateProtectionSet(this.selectedSubscription, protectionSetToUpdate).then(res => {
            this.$rootScope.$emit("protection-set-edit");
        }, err => { }).finally(() => {
            this.selectedResourceGroups = [];
            this.searchTree = '';
            this.load();
            this.changeState(this.MAIN_STATE);
        });
    }

    deleteProtectionSet() {
        this.dialogService.showYesNo(this.$filter('translate')('vm.vmGroups.deleteDialog.text', { name: this.selectedProtectionSet.name }) + '\n\n\n' + this.$filter('translate')('vm.vmGroups.deleteDialog.text2'), this.$filter('translate')('vm.vmGroups.deleteDialog.title'), null, 'delete-cg')
            .then(result => {
                if (result) {
                    this.busy = true;
                    this.reload = true;
                    return this.persistence.deleteProtectionSet(this.selectedSubscription, this.selectedProtectionSet);
                }
            })
            .then(res => {
                if (res) {
                    this.notificationService.pop(res.data.message);
                    this.sharedPersistenceService.getProtectionSets().then(protectionSets => {
                        if (this.selectedProtectionSet.name === this.storageService.getProtectionSet().name) {
                            this.storageService.setProtectionSet(protectionSets.filter(protectionSet => protectionSet.default === true)[0]);
                            this.selectedProtectionSet = protectionSets.filter(protectionSet => protectionSet.default === true)[0];
                            this.persistence.saveProtectionSet(this.selectedSubscription, this.selectedProtectionSet);
                        }
                        this.onDelete();
                    });
                    this.setProtectionSetsTable();
                }
            }, err => {
                this.busy = false;
            });
    }

    editProtectionSet() {
        this.searchRg = "";
        this.protectionSet = this.persistence.newProtectionSet();
        this.protectionSet.uuid = this.selectedProtectionSet.uuid;
        this.protectionSet.name = this.selectedProtectionSet.name;
        this.busy = true;
        this.persistence.getResourceGroups(this.selectedSubscription).then(
            resourceGroups => {
                this.resourceGroups = resourceGroups;
                this.busy = false;
            }
        );
        this.selectedResourceGroups = this.selectedProtectionSet.items;
        this.changeState(this.EDIT_STATE);
    }

    saveProtectionSetSelection() {
        this.persistence.saveProtectionSet(this.selectedSubscription, this.selectedProtectionSet).then((res) => {
            this.storageService.setProtectionSet(this.selectedProtectionSet);
            this.storageService.setManagerHostname(this.selectedSubscription.managerEndpointUrl);
            this.serverUrl = this.storageService.getManagerHostname();
            if (this.selectedSubscription !== this.storageService.getSubscription()) {
                this.sseService.closeSSEStream(false);
                this.storageService.setSubscription(this.selectedSubscription);
                this.sseService.addEventListener('sse', this.selectedSubscription.managerEndpointUrl);
            }
            this.notificationService.pop(res.message);
            this.showModal = false;
            this.onSave();
        });
    }

    enableProtectionSetManage() {
        // this.isEdit ? this.isEdit = false : this.isEdit = true;;
    }

    onModalBack() {
        $("#protection-set-tree-table").off();
        if (this.state !== this.MAIN_STATE) {
            this.selectedProtectionSet = null;
            this.resourceGroups = [];
            this.state = this.MAIN_STATE;
            this.modalTitle = this.mainTitle;
            this.modalSubTitle = null;
            this.expandedItems = [];
            this.bindOnClickFunction();
            return { preventDefault: true };
        }
    }

    onModalClose() {
        $("#protection-set-tree-table").off();
        this.searchTree = '';
        this.searchRg = '';
        this.modalSubTitle = null;
        this.resourceGroups = [];
        this.pickerTableArray = [];
        this.expandedItems = [];
        this.protectionSets = [];
        this.onClose();
    }

    isCreatePsDisabled() {
        return !this.hasCreatePsPermissions();
    }

    isUpdatePsDisabled() {
        return !this.selectedProtectionSet || !this.hasUpdatePsPermissions() || this.selectedProtectionSet.name === 'default';
    }

    isDeletePsDisabled() {
        return this.isDefaultResourceGroup() || (!this.selectedProtectionSet && !this.selectedResourceGroup) || this.selectedProtectionSet && this.selectedProtectionSet.name === 'default' || !this.hasDeletePsPermissions();
    }

    hasCreatePsPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.PS_CREATE, true);
    }

    hasUpdatePsPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.PS_UPDATE, true);
    }

    hasDeletePsPermissions() {
        return this.iamPersistenceService.hasPermissions(permissions.PS_DELETE, true);
    }

}

ProtectionSetPickerController.$inject = ['$element', '$scope', '$rootScope', '$filter', '$timeout', '$document', '$compile', 'storageService', 'contentSwitcherService', 'validationsService', 'dialogService', 'protectionSetPickerPersistence', 'notificationService', 'sharedPersistenceService', 'sseService', 'loginService', 'principalService', 'iamPersistenceService'];

const protectionSetPickerComponent = {
    controller: ProtectionSetPickerController,
    template: require('./protectionSetPicker.template.html'),
    bindings: {
        showModal: '=',
        onSave: '&',
        onDelete: '&',
        // isEdit: '=',
        onClose: '&'
    }
};

module.exports = protectionSetPickerComponent;


// WEBPACK FOOTER //
// ./src/azurebackup/views/mainApp/dialogs/protectionSetPicker/protectionSetPicker.component.js